<template>
  <div v-if="loading" class="loading">Aguarde ...</div>
  <div v-else class="container-fluid">
    <div class="col-sm-12 text-left">
      <h3>
        <router-link to="/mensagens">Mensagens</router-link> » <router-link to="/mensagem/c/0">Adicionar</router-link>
      </h3>
    </div>
    <table>
      <tr>
        <td>#</td>
        <td></td>
        <td>mensagem</td>
        <td class="text-center">validade</td>
        <td>Qtd.</td>
      </tr>
      <tr v-for="msg in mensagens">
        <td><a @click.prevent="select4edit(msg.cod)" class="glyphicon glyphicon-pencil" title="Editar"></a></td>
        <td><a @click.prevent="select4list(msg.cod)" class="glyphicon glyphicon-list" title="Selecionar clientes"></a></td>
        <td v-html="msg.msg"></td>
        <td class="text-center">{{msg.dt_fim}}</td>
        <td>{{msg.qtd}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'userlist',
    data () {
      return {
        loading: false,
        mensagens: []
      }
    },
    methods: {
      load (params = '') {
        const url = './api/php/getmsg.php'
        this.$http.post(url, JSON.stringify(params)).then(
          function (response) {
            console.log(response.body)
            if (response.body.status) {
              this.mensagens = response.body.rows
            } else {
              this.mensagens = []
            }
          },
          function (error) {
            console.log(error)
          }
        )
      },
      select4edit (cod) {
        this.$router.push({path: `/mensagem/u/${cod}`})
      },
      select4list (cod) {
        this.$router.push({path: `/mensagens/${cod}`})
      }
    },
    created: function () {
      this.load({'rel': true})
    },
    watch: {
      '$route' (to, from) {
        this.load({'rel': true})
      }
    }
  }
</script>

<style scoped>
    .container-fluid {
      width: 80vw;
      margin: auto;
    }
    table {
      font: 12px sans-serif;
      color: #333;
      border-collapse: collapse;
      outline: 2px solid #333;
      text-align: left;
      width: 100%;
    }
    table tr {
      background: #fcfcfc;
    }
    table tr:nth-child(2n+1) {
      background: #f1f1f1;
    }
    table tr:hover{
      background: #ccc;
    }
    table tr:first-child {
      background: #333;
      color: #fff;
      text-transform: uppercase;
    }
    table tr td {
      padding: 5px;
    }
    table tr td small {
      color: #777;
    }
    a.glyphicon {
      text-decoration: none;
    }
    @media(max-width: 762px) {
      .container-fluid {
        width: 100vw;
        margin: 0px;
        padding: 5px;
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/MensagemRel.vue